import {
    SET_WEEK_COUNT,
    SET_WEEK_START,
    GET_USERS,
    GET_RAW_JOBPACKS,
    SET_CLICKED_EVENT_SEGMENT,
    SET_JOBPACK_DATES,
    SET_ARRANGED_JOBPACKS,
    SET_SELECTED_JOBPACK_ID,
    GET_ROSTER_IS_LOCKED,
    SET_ROSTER_IS_LOCKED,
} from "./types";

import moment from "moment";
import {
    selectPreviousWeekStart,
    selectNextWeekStart,
    selectArrangedJobpacksFromRawJobpacks,
    selectClickedEventSegment,
    selectWeekCount,
    selectArrangedJobpacksFromStore,
    selectWeekStart,
} from "./selectors";
import { push } from "connected-react-router";
import firebase from "firebase/app";
import "firebase/database";
import { get } from "lodash";

export const setWeekCount = (weekCount = false) => {
    return (dispatch, getStore) => {
        if (!weekCount) return;

        const store = getStore();
        let weekStart = selectWeekStart(store);
        const weekStartString = moment(weekStart)
            .format("DD-MM-YYYY")
            .toString();
        dispatch(
            push(
                `/job-pack-manager/roster/date/${weekStartString}/${weekCount}`
            )
        );
    };
};

export const incrementWeekStart = () => {
    return (dispatch, getStore) => {
        const store = getStore();
        let weekStart = selectNextWeekStart(store);
        const weekCount = selectWeekCount(store);
        const weekStartString = moment(weekStart)
            .format("DD-MM-YYYY")
            .toString();
        dispatch(
            push(
                `/job-pack-manager/roster/date/${weekStartString}/${weekCount}`
            )
        );
    };
};

export const initialise = (startDate = false, weekCount = false) => {
    return (dispatch) => {
        if (startDate === false) {
            startDate = moment().startOf("isoWeek").toDate();
        } else {
            startDate = moment(startDate, "DD-MM-YYYY").toDate();
        }

        if (weekCount === false) {
            weekCount = 1;
        }

        dispatch({ type: SET_WEEK_START, payload: startDate });
        dispatch({ type: SET_WEEK_COUNT, payload: parseInt(weekCount) });
        dispatch(setArrangedJobpacks());
    };
};

export const decrementWeekStart = () => {
    return (dispatch, getStore) => {
        const store = getStore();
        let weekStart = selectPreviousWeekStart(store);
        const weekCount = selectWeekCount(store);
        const weekStartString = moment(weekStart)
            .format("DD-MM-YYYY")
            .toString();
        dispatch(
            push(
                `/job-pack-manager/roster/date/${weekStartString}/${weekCount}`
            )
        );
        dispatch({ type: SET_WEEK_START, payload: weekStart });
        dispatch(setArrangedJobpacks());
    };
};

export const getUsers = () => {
    return (dispatch) => {
        dispatch({ type: GET_USERS.REQUEST });

        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: GET_USERS.FAIL,
                });
            } else {
                firebase
                    .database()
                    .ref(`/users`)
                    .on("value", (snapshot) => {
                        dispatch({
                            type: GET_USERS.SUCCESS,
                            payload: snapshot.val(),
                        });
                    });
            }
        });
    };
};

export const setArrangedJobpacks = () => {
    return (dispatch, getStore) => {
        const store = getStore();
        const arrangedJobpacks = selectArrangedJobpacksFromRawJobpacks(store);

        dispatch({
            type: SET_ARRANGED_JOBPACKS,
            payload: arrangedJobpacks,
        });
    };
};

export const getJobpacks = (year, month) => {
    return (dispatch, getStore) => {
        dispatch({
            type: GET_RAW_JOBPACKS.REQUEST,
        });
        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: GET_RAW_JOBPACKS.FAIL,
                });
            } else {
                firebase
                    .database()
                    .ref(`/subjects/jobpacks/active`)
                    .on("value", (snapshot) => {
                        dispatch({
                            type: GET_RAW_JOBPACKS.SUCCESS,
                            payload: snapshot.val(),
                        });

                        const store = getStore();
                        const arrangedJobpacks = selectArrangedJobpacksFromStore(
                            store
                        );

                        if (
                            arrangedJobpacks === false ||
                            Object.keys(arrangedJobpacks).length === 0
                        ) {
                            dispatch(setArrangedJobpacks());
                        }
                    });
            }

            // dispatch({
            //     type: GET_RAW_JOBPACKS.SUCCESS,
            //     payload: MockJobpacks
            // });
        });
    };
};

export const setClickedEventSegment = (segment) => {
    return (dispatch) => {
        dispatch({
            type: SET_CLICKED_EVENT_SEGMENT,
            payload: JSON.parse(JSON.stringify(segment)),
        });
    };
};

export const setJobpackDates = (
    jobpackID,
    status,
    timestamp,
    startDate = false,
    endDate = false
) => {
    return (dispatch) => {
        let updateObject = {};

        dispatch({
            type: SET_JOBPACK_DATES.REQUEST,
        });
        if (startDate !== false) {
            updateObject = { ...updateObject, start_date: startDate };
        }
        if (endDate !== false) {
            updateObject = { ...updateObject, end_date: endDate };
        }
        if (status !== false) {
            updateObject = { ...updateObject, status };
        }
        if (timestamp !== false) {
            updateObject = { ...updateObject, timestamp };
        }
        const year = moment(timestamp, "DD-MM-YYYY HH:mm:ss").format("YYYY");
        const month = moment(timestamp, "DD-MM-YYYY HH:mm:ss")
            .format("MMM")
            .toLowerCase();
        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: SET_JOBPACK_DATES.FAIL,
                });
            } else {
                try {
                    firebase
                        .database()
                        .ref(
                            `/subjects/jobpacks/${status}/${year}/${month}/${jobpackID}/profile`
                        )
                        .update(updateObject)
                        .then(() => {
                            dispatch({
                                type: SET_JOBPACK_DATES.SUCCESS,
                            });
                        });
                } catch (e) {
                    dispatch({
                        type: SET_JOBPACK_DATES.FAIL,
                    });
                }
            }
        });
    };
};

export const getDateStringFromMoment = (weekStart, add) => {
    const weekStartMoment = moment(weekStart);

    return weekStartMoment.add(add, "days").format("DD-MM-YYYY").toString();
};

export const setSelectedJobpackID = (jobpackID) => {
    return (dispatch) => {
        dispatch({ type: SET_SELECTED_JOBPACK_ID, payload: jobpackID });
    };
};

export const setEventDate = (movingColumnIndex, movingRowIndex) => {
    return (dispatch, getStore) => {
        const store = getStore();
        const clickedEventSegment = selectClickedEventSegment(store);
        const weekCount = selectWeekCount(store);
        const weekStart = selectWeekStart(store);

        if (movingColumnIndex < 0 || movingColumnIndex >= weekCount * 7) {
            return;
        }

        const jobpacks = selectArrangedJobpacksFromStore(store);

        const eventUid = get(clickedEventSegment, "event.uid") || false;
        const eventStatus = get(clickedEventSegment, "event.status") || false;
        const eventTS = get(clickedEventSegment, "event.timestamp") || false;
        const type = get(clickedEventSegment, "type") || false;
        const columnIndex = get(clickedEventSegment, "columnIndex") || false;
        let startDate = false;
        let endDate = false;
        switch (type) {
            case "resizeLeft": {
                jobpacks[eventUid]["startIndex"] = movingColumnIndex;
                startDate = getDateStringFromMoment(
                    weekStart,
                    movingColumnIndex
                );
                break;
            }

            case "resizeRight": {
                jobpacks[eventUid]["endIndex"] = movingColumnIndex;
                endDate = getDateStringFromMoment(weekStart, movingColumnIndex);
                break;
            }
            case "move": {
                const columnDelta = movingColumnIndex - columnIndex;
                const initialEventState =
                    get(clickedEventSegment, "event") || false;

                const newStartIndex =
                    initialEventState.startIndex + columnDelta;
                let newEndIndex = initialEventState.endIndex + columnDelta;

                jobpacks[eventUid]["row"] = movingRowIndex;
                jobpacks[eventUid]["startIndex"] = newStartIndex;
                jobpacks[eventUid]["endIndex"] = newEndIndex;
                const width = newEndIndex - newStartIndex;

                if (width === 0) {
                    newEndIndex = newStartIndex;
                }
                startDate = getDateStringFromMoment(weekStart, newStartIndex);
                endDate = getDateStringFromMoment(weekStart, newEndIndex);

                break;
            }

            default:
                break;
        }

        dispatch({ type: SET_ARRANGED_JOBPACKS, payload: jobpacks });
        dispatch(
            setJobpackDates(eventUid, eventStatus, eventTS, startDate, endDate)
        );
    };
};

export const navigateTo = (url) => {
    return (dispatch) => {
        dispatch(push(url));
    };
};

export const getIsLocked = () => {
    return (dispatch) => {
        dispatch({
            type: GET_ROSTER_IS_LOCKED.REQUEST,
        });
        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: GET_ROSTER_IS_LOCKED.FAIL,
                });
            } else {
                try {
                    firebase
                        .database()
                        .ref(`/dashboard/roster/ui/is_locked`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_ROSTER_IS_LOCKED.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } catch (e) {
                    dispatch({
                        type: GET_ROSTER_IS_LOCKED.FAIL,
                    });
                }
            }
        });
    };
};

export const setIsLocked = (isLocked) => {
    return (dispatch) => {
        dispatch({
            type: SET_ROSTER_IS_LOCKED.REQUEST,
        });
        firebase.auth().onAuthStateChanged(async (user) => {
            if (user === null) {
                dispatch({
                    type: SET_ROSTER_IS_LOCKED.FAIL,
                });
            } else {
                try {
                    await firebase
                        .database()
                        .ref(`/dashboard/roster/ui`)
                        .update({ is_locked: isLocked });
                    dispatch({
                        type: SET_ROSTER_IS_LOCKED.SUCCESS,
                    });
                } catch (e) {
                    dispatch({
                        type: SET_ROSTER_IS_LOCKED.FAIL,
                    });
                }
            }
        });
    };
};
